namespace GeniuzPOS.InitialData {
    export enum PsPosStationEumConnectEDCFg {
        ConnectEDCFgNo = 0,
        ConnectEDCFgYes = 1
    }
    Serenity.Decorators.registerEnumType(PsPosStationEumConnectEDCFg, 'GeniuzPOS.InitialData.PsPosStationEumConnectEDCFg');
}
